import { Box, FlexBox } from '@dixa/lib-shared-habla';
import cx from 'classnames';

import { useSidebarCollapsed } from 'hooks/useSidebarCollapsed';

import sidebarStyles from '../collectionSidebar/sidebar.module.scss';

import placeholderStyles from './placeholders.module.scss';

export function CollectionSidebarPlaceholder(): JSX.Element {
  const [isCollapsed] = useSidebarCollapsed();
  const placeholder = placeholderStyles.placeholder;
  const IconAndBar = () => (
    <FlexBox
      gap="16px"
      alignItems={'center'}
      justifyContent={isCollapsed ? 'center' : undefined}
      padding="8px 16px"
    >
      <Box height="16px" width="16px" className={placeholder} />
      {!isCollapsed && (
        <Box height="14px" width="120px" className={placeholder} />
      )}
    </FlexBox>
  );

  return (
    <FlexBox
      className={cx(sidebarStyles.sidebar, {
        [sidebarStyles.sidebarCollapsed]: isCollapsed,
      })}
    >
      <Box>
        <IconAndBar />
        {!isCollapsed && (
          <FlexBox padding="10px 16px">
            <Box height="12px" width="80px" className={placeholder} />
          </FlexBox>
        )}
        <IconAndBar />
        <IconAndBar />
        <IconAndBar />
        <IconAndBar />
      </Box>
      <Box>
        <IconAndBar />
      </Box>
    </FlexBox>
  );
}
